import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import { Grid } from '@material-ui/core';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { getLotSerialInputPlaceHolder } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import Select from 'src/common/refactoredComponents/select/Select';
import QuantityRPInputBoxes from '../../QuantityRPInputBoxes';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from 'src/pages/consignmentBilling/components/billing/BillingContainer.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';


const LotSerialRPQtyInputMobile = forwardRef((props, ref) => {
    const {
        item,
        index,
        lotItem,
        lotItemIdx,
        addSerialNumber,
        lotSerialValueEntered,
        showTopLabel,
        deleteItem,
        showBundlefromTableList,
        isChildItem,
        isFromReportScreen,
        checkNewAddedProduct,
        onIsSerialUnknown,
    } = props;
    const { t } = useTranslation();
    const deleteBtnHeightWidth = showTopLabel
        ? '32px !important'
        : '32px !important';

    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );
    const bottomLabelClickHandler = () => {
        if (item.isBundleItem) {
            showBundlefromTableList(true, index, item.productCFN, item?.unqId);
        } else {
            addSerialNumber(item, index);
        }
    };
useImperativeHandle(ref, () => ({
    bottomLabelClickHandler,
}));
    const [showClear, setShowClear] = useState(false);
    const [lot, setLot] = useState('');

    useEffectWithErrorLogging(() => {
        setLot(item?.lotSerialNumber ? item?.lotSerialNumber : '');
        setShowClear(item?.lotSerialNumber ? true : false);
    }, [lotItem]);

    return (
        <>
            {!checkNewAddedProduct && isFromReportScreen ? (
                <Box
                    style={{
                        fontSize: '13px',
                        marginLeft: '5px',
                        fontFamily: 'AvenirNextWorld Regular',
                    }}
                >
                    {item.isBundleItem
                        ? t(
                              'reportUsage.itemList.lotSerialInputPlaceHolder.notApplicable'
                          )
                        : item.lotSerialNumber}
                </Box>
            ) : (
                <>
                    {isFromReportScreen && checkNewAddedProduct && (
                        <>
                            <LotSerialInputBox>
                                {
                                    <Grid
                                        item
                                        // sm={6}
                                        style={{
                                            fontFamily: 'AvenirNextWorld Demi',
                                            fontSize: '12px',
                                            textAlign: 'left',
                                        }}
                                    >
                                        {item?.productCFN?.startsWith('S33')
                                            ? t(
                                                  'reportUsage.record.reportPayment.LotSerialRPQtyInput.vendorCaseID'
                                              )
                                            : t(
                                                  'reportUsage.record.itemsList.LotSerialQtyInput.lotSerial'
                                              )}
                                    </Grid>
                                }
                                {item.batches?.length > 0 ? (
                                    <Select
                                        id="reportUsage-lotSerialRPQtyInputMobile-reportPayment-batches"
                                        value={lot}
                                        options={item.batches}
                                        name={'batches'}
                                        onChange={(e) => {
                                            lotSerialValueEntered(
                                                e,
                                                item,
                                                index
                                            );
                                            setLot(e.batches);
                                            setShowClear(e.batches?.length > 0);
                                        }}
                                        placeholder={getLotSerialInputPlaceHolder(
                                            item,
                                            t('reportUsage.unknown')
                                        )}
                                        borderRadius={'6px'}
                                        border={'1.5px solid #EBEDED'}
                                        width={'140px'}
                                        editable={true}
                                        showClear={showClear}
                                        crossIconMargin={'-5px'}
                                        showOnFocus={true}
                                    />
                                ) : (
                                    <TextWithInputs
                                        width={'140px'}
                                        // sm={6}
                                        lg={6}
                                        md={6}
                                        name={'lotSerialNumber'}
                                        topLabel={
                                            showTopLabel &&
                                            t(
                                                'reportUsage.record.itemsList.LotSerialQtyInput.lotSerial'
                                            )
                                        }
                                        placeholder={getLotSerialInputPlaceHolder(
                                            item,
                                            t('reportUsage.unknown')
                                        )}
                                        inputDisabled={
                                            item.isBundleItem ||
                                            (item?.productCFN?.startsWith(
                                                'S33'
                                            ) &&
                                                usageDetails?.vendorCaseId?.startsWith(
                                                    'UH_'
                                                ))
                                        }
                                        onLabelClick={bottomLabelClickHandler}
                                        onkeyUp={(e) =>
                                            !item?.lotSerialUnknown &&
                                            lotSerialValueEntered(
                                                e,
                                                item,
                                                index
                                            )
                                        }
                                        isBundleItem={item.isBundleItem}
                                        cursor={'pointer'}
                                        inputBorder={
                                            item.isInvalidLotSerialMsg?.length >
                                                0 && '2px solid #FACFD6'
                                        }
                                        lotSerial={true}
                                        defaultValue={
                                            item?.lotSerialUnknown
                                                ? ''
                                                : item?.lotSerialNumber
                                        }
                                        value={
                                            item?.lotSerialUnknown
                                                ? ''
                                                : item?.lotSerialNumber
                                        }
                                        inputHeight={'44px'}
                                        bottomLabel={
                                            !item.isInvalidItemMsg &&
                                            item.isBundleItem &&
                                            t(
                                                'reportUsage.record.reportPayment.LotSerialRPQtyInput.addItems'
                                            )
                                        }
                                        noItemInBundleErr={
                                            item.noItemInBundleErr
                                        }
                                    />
                                )}
                            </LotSerialInputBox>
                            {
                                <>
                                    <QuantityRPInputBoxes
                                        item={item}
                                        index={index}
                                        lotItem={lotItem}
                                        lotItemIdx={lotItemIdx}
                                        lotSerialValueEntered={
                                            lotSerialValueEntered
                                        }
                                        showTopLabel={
                                            showTopLabel && lotItemIdx === 0
                                        }
                                        isChildItem={isChildItem}
                                        isFromReportScreen={isFromReportScreen}
                                        checkNewAddedProduct={
                                            checkNewAddedProduct
                                        }
                                        mbLabelLineHeight={'25px'}
                                    />

                                    <DeleteButtonContainer
                                        alignItems={'flex-end'}
                                        height={
                                            window.innerWidth <=
                                                sizes.mobileDevice && '75%'
                                        }
                                    >
                                        <Box
                                            id={`reportUsage-reportPayment-mobile-item-delete-button-${item.productCFN}-${index}`}
                                            component={Button}
                                            aria-controls="simple-menu-1"
                                            aria-hospopup="true"
                                            size="small"
                                            width={deleteBtnHeightWidth}
                                            height={deleteBtnHeightWidth}
                                            minWidth={deleteBtnHeightWidth}
                                            minHeight={deleteBtnHeightWidth}
                                            border="1px solid #EBEBEB"
                                            marginRight={
                                                !item.isBundleItem && '-5px'
                                            }
                                            marginTop={
                                                showTopLabel &&
                                                (lotItemIdx === 0
                                                    ? '20px'
                                                    : '5px')
                                            }
                                            borderRadius={6}
                                            onClick={() =>
                                                deleteItem(index, 0, null, item)
                                            }
                                        >
                                            <img
                                                src={DeleteLight}
                                                height={showTopLabel ? 20 : 24}
                                                width={showTopLabel ? 20 : 24}
                                            />
                                        </Box>
                                    </DeleteButtonContainer>
                                </>
                            }
                        </>
                    )}
                </>
            )}
        </>
    );
});

export default LotSerialRPQtyInputMobile;

export const LotSerialInputBox = styled.div`
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
         justify-content: space-between;
    `}
`;
export const DeleteButtonContainer = styled.div`
    display: flex;
    align-items: ${({ alignItems }) => alignItems};
    margin-top: ${({ marginTop }) => marginTop};
    padding-top: ${({ paddingBottom }) => paddingBottom};
    width: 32px;
    height: ${({ height }) => height};
    ${media.mediumDevice`
        display: block;
        margin-top: ${({ marginTop }) => (marginTop ? marginTop : '25px')}
    `}
`;
